exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-invite[data-v-cc6a9d32]{background-color:#00ad9e}table tbody tr[data-v-cc6a9d32]{-webkit-transition:all .1s linear;transition:all .1s linear}table tbody tr[data-v-cc6a9d32]:hover{background-color:#f5f5f5}.v-list-item[data-v-cc6a9d32]{min-height:27px;font-size:13px}", ""]);

// exports
